import { apiBaseUrl } from 'App';
import type { RequestParameters } from 'mapbox-gl';

// Placeholder access token, mapbox-gl requires a non-empty string but every
// request gets rewritten to our own backend proxy before it is ever used
export const mapboxPlaceholderAccessToken = 'not-used-requests-are-proxied';

// Rewrites every mapbox-gl request (style, tiles, fonts, sprites) to go
// through our own backend proxy, so the real mapbox token never reaches
// the browser and every request is gated behind our own login and feature flag
export const transformMapboxRequest = (url: string): RequestParameters => {

    // Leave non mapbox requests untouched
    if (!url.includes('api.mapbox.com')) {
        return { url };
    }

    // Strip the placeholder access token, our backend attaches its own
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.delete('access_token');
    const path = `${parsedUrl.pathname}${parsedUrl.search}`;

    return {
        url: `${apiBaseUrl}/get_mapbox_resource/?path=${encodeURIComponent(path)}`,
        credentials: 'include',
    };
};
